import React, { useEffect } from "react";
import { atom, useAtom } from "jotai";
import { Toast } from "primereact/toast";
import { toastState } from "../states/toastState";

const ToastGlobal = () => {
  const [toastConfig, setToastConfig] = useAtom(toastState);
  const toastRef = React.useRef(null);

  useEffect(() => {
    if (toastConfig.visible && toastRef.current) {
      toastRef.current.show({
        severity: toastConfig.severity,
        summary: toastConfig.summary,
        detail: toastConfig.detail,
        life: toastConfig.life,
      });
      // Reset visible to false after showing
      setToastConfig((prev) => ({ ...prev, visible: false }));
    }
  }, [toastConfig, setToastConfig]);

  return <Toast ref={toastRef} />;
};

export default ToastGlobal;
